import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext } from "react";

import { PortalRegistrationState } from "@/Common/Models/Portal/Enums/PortalRegistrationState";

interface InvitationPopupValue {
    redirect: () => void;
    resending: boolean;
    setResending?: Dispatch<SetStateAction<boolean>>;
    createOwn: boolean;
    setCreateOwn?: Dispatch<SetStateAction<boolean>>;
    hasAccount: boolean;
    unlocking: boolean;
    accountStatus: PortalRegistrationState;
    underAgeOfConsent: { dateOfBirth: Date, check: boolean };
    representatives: { contactId: string; permissions: number[] }[];
    anyRepresentative: boolean;
}

const InvitationPopupContext = createContext<InvitationPopupValue>({
    redirect: () => {},
    resending: false,
    createOwn: false,
    hasAccount: false,
    unlocking: false,
    accountStatus: PortalRegistrationState.Default,
    underAgeOfConsent: { dateOfBirth: new Date(), check: false },
    representatives: [],
    anyRepresentative: false
});

function useInvitationPopup(): InvitationPopupValue {
    return useContext(InvitationPopupContext);
}

function InvitationPopupProvider(props: PropsWithChildren<InvitationPopupValue>): JSX.Element {
    const {
        redirect,
        resending,
        setResending,
        createOwn,
        setCreateOwn,
        hasAccount,
        unlocking,
        accountStatus,
        underAgeOfConsent,
        representatives,
        anyRepresentative,
        children
    } = props;

    return (
        <InvitationPopupContext.Provider
            value={{
                redirect,
                resending,
                setResending,
                createOwn,
                setCreateOwn,
                hasAccount,
                unlocking,
                accountStatus,
                underAgeOfConsent,
                representatives,
                anyRepresentative
            }}
        >
            {children}
        </InvitationPopupContext.Provider>
    );
}

export type { InvitationPopupValue };

export { InvitationPopupContext, InvitationPopupProvider, useInvitationPopup };
